import type { PluginRegistryEntry } from './plugins/types';

// OAuth callback path — must match the Cognito app client's callback URLs
// (infra/cognito.py registers `<origin>/oauth/complete`).
export const OAUTH_CALLBACK_PATH = '/oauth/complete';

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is not set. In production it is baked in at build time; ` +
        'for local dev copy ui/.env.example to ui/.env.local and fill it in.'
    );
  }
  return value;
}

export const oidc = {
  issuer: required('VITE_OIDC_ISSUER', import.meta.env.VITE_OIDC_ISSUER),
  clientId: required('VITE_OIDC_CLIENT_ID', import.meta.env.VITE_OIDC_CLIENT_ID),
  authorizeEndpoint: required(
    'VITE_OIDC_AUTHORIZE_ENDPOINT',
    import.meta.env.VITE_OIDC_AUTHORIZE_ENDPOINT
  ),
  tokenEndpoint: required(
    'VITE_OIDC_TOKEN_ENDPOINT',
    import.meta.env.VITE_OIDC_TOKEN_ENDPOINT
  ),
  revocationEndpoint: (import.meta.env.VITE_OIDC_REVOCATION_ENDPOINT ??
    '') as string,
  endSessionEndpoint: (import.meta.env.VITE_OIDC_END_SESSION_ENDPOINT ??
    '') as string,
  scopes: (import.meta.env.VITE_OIDC_SCOPES as string | undefined) ||
    'openid profile email',
};

function parseRegistry(raw: string | undefined): PluginRegistryEntry[] {
  if (!raw) return [];
  const parsed: unknown = JSON.parse(raw);
  if (!Array.isArray(parsed)) {
    throw new Error('VITE_PLUGIN_REGISTRY must be a JSON array');
  }
  return parsed as PluginRegistryEntry[];
}

/** The plugin registry, fixed at build time from the stack config. */
export const pluginRegistry: PluginRegistryEntry[] = parseRegistry(
  import.meta.env.VITE_PLUGIN_REGISTRY
);
